<template>
  <v-container>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              label="帳號"
              v-model="userid"
              outlined
              dense
              :rules="[(v) => !!v || '請輸入帳號']"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="密碼"
              v-model="pwd"
              outlined
              dense
              :rules="[(v) => !!v || '請輸入密碼']"
              :append-icon="showpwd ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showpwd ? 'text' : 'password'"
              @click:append="showpwd = !showpwd"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn color="success" @click="login" :disabled="!valid"
              >登入</v-btn
            >
            <v-btn color="error" class="ml-4" @click="dialog2 = true"
              >忘記密碼</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-form ref="form1" v-model="valid1" lazy-validation>
          <v-card-title>
            <span class="headline">首次登入，需修改密碼。</span>
          </v-card-title>

          <v-text-field
            label="變更密碼*"
            v-model="pwd1"
            outlined
            dense
            :rules="[(v) => !!v || '請輸入密碼']"
            required
          ></v-text-field>

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="生日*(查詢密碼時核對身分使用)"
                v-model="date"
                outlined
                dense
                :rules="[(v) => !!v || '請選擇日期']"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="date"
              :max="new Date().toISOString().substr(0, 10)"
              min="1950-01-01"
              @change="save"
            ></v-date-picker>
          </v-menu>

          <v-card-actions>
            <v-spacer
              ><div>{{ msgSho }}</div></v-spacer
            >
            <v-btn color="blue darken-1" text :disabled="!valid1" @click="renew"
              >確認修改</v-btn
            >
            <v-btn color="blue darken-1" text @click="dialog = false"
              >關閉</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog1" persistent max-width="200px">
      <v-card>
        <v-card-title>
          <span class="headline">登入失敗。</span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog1 = false"
            >關閉</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" persistent max-width="600px">
      <v-card>
        <v-form ref="form2" v-model="valid2" lazy-validation>
          <v-card-title>
            <span class="headline">忘記密碼(還原為預設密碼)</span>
          </v-card-title>

          <v-text-field
            label="帳號"
            v-model="userid1"
            outlined
            dense
            :rules="[(v) => !!v || '請輸入帳號']"
          ></v-text-field>

          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="生日*"
                v-model="date1"
                outlined
                dense
                :rules="[(v) => !!v || '請選擇日期']"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker1"
              v-model="date1"
              :max="new Date().toISOString().substr(0, 10)"
              min="1950-01-01"
              @change="save1"
            ></v-date-picker>
          </v-menu>

          <v-card-actions>
            <v-spacer
              ><div>{{ msgSho1 }}</div></v-spacer
            >
            <v-btn
              color="blue darken-1"
              text
              :disabled="!valid2"
              @click="forget"
              >確認還原</v-btn
            >
            <v-btn color="blue darken-1" text @click="dialog2 = false"
              >關閉</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-overlay v-model="loading" class="text-center">
      <p>讀取中......</p>
      <v-progress-circular size="50" indeterminate />
    </v-overlay>
  </v-container>
</template>

<script>
import api from "../utils/apis/AdMedicalApi.js";

export default {
  data: () => ({
    //
    userid: "",
    userid1: "",
    pwd: "",
    pwd1: "",
    showpwd: false,
    valid: null,
    valid1: null,
    valid2: null,
    loading: false,
    dialog: false,
    dialog1: false,
    dialog2: false,
    date: null,
    date1: null,
    menu: false,
    menu1: false,
    msgSho: "",
    msgSho1: "",
    recLogin: {},
    recPwdUpd: {},
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = "YEAR"));
    },
  },
  methods: {
    async login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var response = await api.PeoLogin({
          PeoCode: this.userid,
          PeoPwd: this.pwd,
          PeoBrd: null,
        });
        // console.log("【:login->PeoLogin:】", response);
        this.recLogin = response.data.Data;
        this.loading = false;

        var IsManager = this.recLogin.IsManager;
        var DepCode;
        if (IsManager) {
          DepCode = this.recLogin.AdminDepCodeIn;
        } else {
          DepCode = [this.recLogin.DepCode];
        }

        if (this.recLogin.LoginRun) {
          this.$store.commit("setLogIn", true);
          this.$store.commit("setUsrId", this.recLogin.PeoCode);
          this.$store.commit("setUsrNa", this.recLogin.PeoName);
          this.$store.commit("setDepNo", DepCode);
          this.$store.commit("setAdmin", IsManager);
          this.$router.push("/");
        } else {
          if (this.recLogin.LoginFirst) {
            this.dialog = true;
            if (this.recLogin.PeoBirthday != null)
              this.date = this.recLogin.PeoBirthday.substr(0, 10);
          } else {
            this.dialog1 = true;
          }
        }
      } else return;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    save1(date1) {
      this.$refs.menu1.save(date1);
    },
    async renew() {
      if (this.userid == this.pwd1) {
        this.msgSho = "【錯誤：帳號不可與變更密碼相同】";
        return;
      }
      if (this.$refs.form1.validate()) {
        this.loading = true;
        this.msgSho = "";
        var response = await api.PeoDataModify({
          PeoCode: this.userid,
          PeoPwd: this.pwd1,
          PeoBrd: this.date,
        });
        // console.log("【:renew->PeoDataModify:】", response);
        this.recPwdUpd = response.data;
        this.loading = false;
        if (this.recPwdUpd.IsSuccess) {
          this.msgSho = "【修改成功，請重新登入】";
          this.valid1 = false;
          this.$store.commit("setLogIn", false);
          this.$router.push("/login");
        }
      } else return;
    },
    async forget() {
      if (this.$refs.form2.validate()) {
        this.loading = true;
        this.msgSho2 = "";

        var response = await api.PeoLogin({
          PeoCode: this.userid1,
          PeoPwd: null,
          PeoBrd: this.date1,
        });
        // console.log("【:forget->PeoLogin:】", response);
        this.recLogin = response.data.Data;
        this.loading = false;

        if (!this.recLogin.LoginRun) {
          this.msgSho1 = "【還原失敗，請重新輸入資料】";
        } else {
          var response2 = await api.PeoDataModify({
            PeoCode: this.userid1,
            PeoPwd: this.userid1,
            PeoBrd: this.date1,
          });
          // console.log("【:forget->PeoDataModify:】", response2);
          this.recPwdUpd = response2.data;
          if (this.recPwdUpd.IsSuccess) {
            this.msgSho1 = "【還原成功，請重新登入】";
            this.valid2 = false;
            this.$store.commit("setLogIn", false);
            this.$router.push("/login");
          }
        }
      } else return;
    },
  },
};
</script>
